module.exports = __webpack_public_path__ + "img/art-17.f20c3586.png";